(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  if (document.referrer && document.referrer.includes('/checkouts/')) {
    localStorage.setItem('redirect_from', 'checkout');
  }
})();

  } catch(e) { console.error(e); }
})();
})();
